import "./App.css";
import React from "react";
import Header from "./components/Header";
import Meme from "./components/Meme";

function App() {
  return (
    <div className="App">
      
        <Header />

        <Meme />

        {/* <h1>Moshi Moshi!</h1> */}
      
    </div>
  );
}

export default App;
